import type { ServiceSeed } from '@/types';
import { carDetailingServices } from './car-detailing';
import { electricianServices } from './electrician';
import { homeCleaningServices } from './home-cleaning';
import { hvacServices } from './hvac';
import { lawnCareServices } from './lawn-care';
import { otherServices } from './other';
import { plumbingServices } from './plumbing';
import { pressureWashingServices } from './pressure-washing';
import { salonSpaServices } from './salon-spa';

/**
 * Services as authored, before their default prices are resolved.
 *
 * `scripts/import-pricing.mjs` reconciles the pricing workbook against these,
 * so this module must never import the generated prices itself.
 */
export const SERVICE_SEED_SETS: Readonly<Record<string, readonly ServiceSeed[]>> = {
  'car-detailing': carDetailingServices,
  'pressure-washing': pressureWashingServices,
  plumbing: plumbingServices,
  electrician: electricianServices,
  hvac: hvacServices,
  'lawn-care': lawnCareServices,
  'home-cleaning': homeCleaningServices,
  'salon-spa': salonSpaServices,
  other: otherServices,
};
